<template>
  <div class="evaluator-avatar">
    <div v-if="evaluatorId" class="avatar avatar-sm">
      <img class="avatar-img user" :src="avatarURL" :alt="fullName" :title="fullName">
    </div>
    <div v-else>
      <img class="avatar-img bot" src="@/ui/assets/img/robot.svg" :alt="fullName" :title="fullName">
    </div>
  </div>
</template>
<script>

import { avatar } from '@/application/services/api-clients/avatar';
import { ShortNameService } from '@/application/services/evaluations/short-name-service';

export default {
  name: 'EvaluatorAvatar',
  props: {
    evaluatorId: {
      type: String,
      required: false
    }
  },
  data() {
    return {
      fullName: ''
    };
  },
  computed: {
    avatarURL() {
      if (this.evaluatorId) {
        return `${avatar.URL(this.evaluatorId)}?time=${new Date().getTime()}`;
      }
      return null;
    }

  },
  async created() {
    await this.fetchFullName();
  },
  methods: {
    async fetchFullName() {
      const serviceShortName = new ShortNameService();
      this.fullName = await serviceShortName.getShortName(this.evaluatorId);
    }
  }
};
</script>

<style scoped>
.evaluator-avatar{
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.avatar-img{
  display: flex;
  margin: 4px;
  border: 1px solid #fff;
  border-radius: 50%;
  padding: 6px;
}

</style>
